export const IMAGE_URL = 'https://s3.amazonaws.com/bendito.customer.storage/images/'
